export default "__VITE_ASSET__C2g32Nio__"